'use client';

import React from 'react';
import classnames from 'classnames';
import Typography from '../../atoms/Typography/Typography';
import IconButton from '../../atoms/IconButton/IconButton';
import styles from './Slider.module.scss';

type Theme = 'dark' | 'light';
type SlideDirection = 'left' | 'right';

interface SliderProps {
  isOpen: boolean;
  onClose: () => void;
  title: string | React.ReactNode;
  width?: string;
  direction?: SlideDirection;
  theme?: Theme;
  children: React.ReactNode;
  footer?: React.ReactNode;
  className?: string;
}

const Slider: React.FC<SliderProps> = ({
  isOpen,
  onClose,
  title,
  width = '400px',
  direction = 'right',
  theme = 'dark',
  children,
  footer,
  className,
}) => {
  return (
    <>
      {/* Overlay */}
      {isOpen && <div className={styles.overlay} onClick={onClose} data-theme={theme} />}

      {/* Slider */}
      <div
        className={classnames(
          styles.slider,
          {
            [styles.open]: isOpen,
            [styles.left]: direction === 'left',
            [styles.right]: direction === 'right',
          },
          className
        )}
        // eslint-disable-next-line react/forbid-dom-props
        style={{ width }}
        data-theme={theme}
      >
        {/* Header */}
        <div className={styles.header}>
          {typeof title === 'string' ? (
            <Typography variant="headline" size="small" theme={theme} color="white">
              {title}
            </Typography>
          ) : (
            title
          )}
          <IconButton
            icon={{ category: 'global', name: 'close' }}
            size="small"
            theme={theme}
            buttonType="tertiary"
            gaComponent="slider-close"
            dataTestId="slider-close-button"
            handleClick={onClose}
          />
        </div>

        {/* Body */}
        <div className={styles.body}>{children}</div>

        {/* Footer */}
        {footer && <div className={styles.footer}>{footer}</div>}
      </div>
    </>
  );
};

Slider.displayName = 'Slider';

export default Slider;
